var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appContainer my-code top_container"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"line"}),_c('h1',[_vm._v(" "+_vm._s(_vm.$t('company-code.header', { split: '/' }))+" ")])]),_c('div',{staticClass:"rc-top"},[_c('div',{staticClass:"rc-container"},[_c('div',{staticClass:"code-container"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }